<template>
  <div>
    <application-template
      template="MERCHANT_APPLICATION_FAILURE"
    ></application-template>
  </div>
</template>

<script>
import { USER_STATUS } from "../utils/const";

export default {
  name: "ApplicationFailed",
  title: "mp:page.application_failed.title",
  components: {
    ApplicationTemplate: () =>
      import("@/components/application/ApplicationTemplate.vue"),
  },
  async mounted() {
    if (!this.$store.getters["profile/isInState"](USER_STATUS.FAILED)) {
      return await this.$router.push(
        this.$store.getters["profile/getBackPath"]
      );
    }
  },
  methods: {},
};
</script>
